// app/frontend/src/pages/interface/components/newProduct/connect/sourceConfigs.ts
import type { SourceId } from "../state";

export type ConnectSourceId = Exclude<SourceId, "files">;

export interface SourceConfig {
    id: ConnectSourceId;
    name: string;
    glyph: string;
    kind: "tracker" | "git";
    selectTitle: string;
    itemsNoun: string;
    syncNote: (count: number | null, selectionSize: number) => string;
    connectField?: { label: string; placeholder: string; required: boolean };
}

const repoNote = (noun: string) => (count: number | null, n: number) =>
    `${n} ${n === 1 ? "repository" : "repositories"} will be indexed into the Context Mesh — structure, commits, and history.`;

export const SOURCE_CONFIGS: Record<ConnectSourceId, SourceConfig> = {
    jira: {
        id: "jira", name: "Jira", glyph: "jira", kind: "tracker",
        selectTitle: "Select project", itemsNoun: "tickets",
        syncNote: count => count != null
            ? `${count} open tickets will be imported into the Context Mesh.`
            : "Open tickets will be imported into the Context Mesh.",
        connectField: { label: "Atlassian Domain", placeholder: "your-company.atlassian.net", required: true }
    },
    azure: {
        id: "azure", name: "Azure DevOps", glyph: "azure", kind: "tracker",
        selectTitle: "Select project", itemsNoun: "work items",
        syncNote: count => count != null
            ? `${count} open work items will be imported into the Context Mesh.`
            : "Open work items will be imported into the Context Mesh.",
        connectField: { label: "Organization URL", placeholder: "https://dev.azure.com/your-org", required: true }
    },
    github: {
        id: "github", name: "GitHub", glyph: "github", kind: "git",
        selectTitle: "Select repositories", itemsNoun: "repos", syncNote: repoNote("repos")
    },
    gitlab: {
        id: "gitlab", name: "GitLab", glyph: "gitlab", kind: "git",
        selectTitle: "Select repositories", itemsNoun: "repos", syncNote: repoNote("repos"),
        connectField: { label: "GitLab URL (Optional)", placeholder: "https://gitlab.com (or self-hosted URL)", required: false }
    },
    bitbucket: {
        id: "bitbucket", name: "BitBucket", glyph: "bitbucket", kind: "git",
        selectTitle: "Select repositories", itemsNoun: "repos", syncNote: repoNote("repos"),
        connectField: { label: "Workspace (Optional)", placeholder: "your-workspace", required: false }
    },
    azuregit: {
        id: "azuregit", name: "Azure DevOps Git", glyph: "azure", kind: "git",
        selectTitle: "Select repositories", itemsNoun: "repos", syncNote: repoNote("repos"),
        connectField: { label: "Organization URL", placeholder: "https://dev.azure.com/your-org", required: true }
    }
};
